import React from "react";
import PropTypes from "prop-types";
import TopBar from "./TopBar";
import NavBar from "./NavBar";
import useSettings from "../contextapi/hooks/useSettings";
import { makeStyles } from '@mui/styles';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  rootAdmin: {
    background: '#fffff',
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  rootAsociado: {
    background:
      'transparent radial-gradient(closest-side at 50% 50%, #003C6B 0%, #001E36 100%) 0% 0% no-repeat padding-box',
    border: '1px solid #707070',
    opacity: 1,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  rootVendedor: {
    border: '1px solid var(--unnamed-color-707070)',
    background:
      'transparent linear-gradient(51deg, #707070 0%, #6F6F7A 14%, #6F6F7B 16%, #6B6CB0 100%) 0% 0% no-repeat padding-box',
    opacity: 1,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 40,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
    marginTop: theme.spacing(5),
  },
  wrapperAsociado: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    marginTop: theme.spacing(5),
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}));



const DashboardLayout = ({ children }) => {
  const { settings } = useSettings();
  const classes = useStyles();
  return (
    <div className={classes.rootAdmin}>
      <TopBar img={settings.Imagen} />
      <NavBar  />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={`${classes.content} scroll`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
